import { Clock, RotateCw } from "lucide-react";
import React from "react";

import { formatTime } from "../lib/utility";

interface ResendCodeButtonProps {
  timeLeft: number;
  isResending: boolean;
  onResend: () => void;
  posthog: any;
}

export default function ResendCodeButton({
  timeLeft,
  isResending,
  onResend,
  posthog,
}: ResendCodeButtonProps) {
  const isDisabled = timeLeft > 0 || isResending;

  const handleClick = () => {
    posthog.capture("enter_otp_resend");
    onResend();
  };

  return (
    <button
      className={`flex min-h-11 w-full items-center justify-center gap-1.5 rounded px-3 text-body-medium transition-colors ${
        isDisabled
          ? "cursor-not-allowed text-ink-secondary"
          : "text-ink underline decoration-border underline-offset-4 hover:decoration-ink"
      }`}
      onClick={isDisabled ? undefined : handleClick}
      disabled={isDisabled}
      type="button"
      name="resend"
    >
      {isResending ? (
        <span className="flex items-center">Sending...</span>
      ) : timeLeft > 0 ? (
        <>
          <Clock aria-hidden className="size-4 shrink-0" strokeWidth={1.75} />
          <span className="tabular-nums">{`Resend code (${formatTime(timeLeft)})`}</span>
        </>
      ) : (
        <>
          <RotateCw aria-hidden className="size-4 shrink-0" strokeWidth={1.75} />
          Resend code (valid for 3 minutes)
        </>
      )}
    </button>
  );
}
